export const DEFAULT_AO_SETTINGS = Object.freeze({ quality: 'auto', intensity: 10, radiusMm: 100, distanceFalloff: 0.3 });
export const AO_QUALITIES = [
  ['auto', 'Automatic'], ['Performance', 'Performance'], ['Low', 'Low'],
  ['Medium', 'Medium'], ['High', 'High'], ['Ultra', 'Ultra']
];

export function validateAOSettings(value = DEFAULT_AO_SETTINGS) {
  if (!value || !AO_QUALITIES.some(([key]) => key === value.quality)) throw new Error('Choose a valid AO quality.');
  for (const [key, label, min, max] of [['intensity', 'strength', 0, 30], ['radiusMm', 'radius (mm)', 1, 500], ['distanceFalloff', 'falloff', 0.01, 2]]) {
    if (!Number.isFinite(value[key]) || value[key] < min || value[key] > max) throw new Error(`AO ${label}: allowed range ${min}–${max}.`);
  }
  return value;
}
